import { render, staticRenderFns } from "./ReversalConfirmation.vue?vue&type=template&id=470e8d9a&scoped=true&"
import script from "./ReversalConfirmation.vue?vue&type=script&lang=js&"
export * from "./ReversalConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470e8d9a",
  null
  
)

export default component.exports